import { Company, Job } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const companies: Company[] = [
  {
    id: 'company-1',
    name: '字节跳动',
    logo: IMAGES.AVATAR_1,
    description: '字节跳动是一家全球化的互联网科技公司，旗下拥有抖音、今日头条等知名产品。我们致力于用技术改变世界，为用户创造价值。',
    industry: '互联网',
    size: '10000+',
    location: '北京',
    website: 'https://www.bytedance.com',
    founded: '2012',
  },
  {
    id: 'company-2',
    name: '腾讯',
    logo: IMAGES.AVATAR_2,
    description: '腾讯是中国领先的互联网增值服务提供商之一，通过互联网服务提升人类生活品质。旗下拥有微信、QQ等亿级用户产品。',
    industry: '互联网',
    size: '10000+',
    location: '深圳',
    website: 'https://www.tencent.com',
    founded: '1998',
  },
  {
    id: 'company-3',
    name: '阿里巴巴',
    logo: IMAGES.AVATAR_3,
    description: '阿里巴巴集团是全球领先的电子商务和云计算公司，致力于让天下没有难做的生意。旗下拥有淘宝、天猫、阿里云等业务。',
    industry: '电子商务',
    size: '10000+',
    location: '杭州',
    website: 'https://www.alibaba.com',
    founded: '1999',
  },
  {
    id: 'company-4',
    name: '美团',
    logo: IMAGES.AVATAR_4,
    description: '美团是中国领先的生活服务电子商务平台，以"帮大家吃得更好，生活更好"为使命，为消费者提供全方位的本地生活服务。',
    industry: '生活服务',
    size: '5000-10000',
    location: '北京',
    website: 'https://www.meituan.com',
    founded: '2010',
  },
];

export const jobs: Job[] = [
  {
    id: 'job-1',
    title: '高级前端工程师',
    company: companies[0],
    location: '北京',
    type: 'full-time',
    category: 'technology',
    salary: {
      min: 30,
      max: 50,
      currency: 'CNY',
    },
    description: '我们正在寻找一位经验丰富的高级前端工程师，负责公司核心产品的前端架构设计和开发工作。你将与产品、设计团队紧密合作，打造极致的用户体验。',
    requirements: [
      '本科及以上学历，计算机相关专业',
      '5年以上前端开发经验',
      '精通React/Vue等主流前端框架',
      '熟悉TypeScript、Webpack等工具',
      '有大型项目架构经验',
      '良好的代码规范和团队协作能力',
    ],
    responsibilities: [
      '负责前端架构设计和技术选型',
      '开发高质量、可维护的前端代码',
      '优化前端性能，提升用户体验',
      '指导初级工程师，进行代码审查',
      '参与产品需求讨论和技术方案评审',
    ],
    benefits: [
      '具有竞争力的薪资待遇',
      '六险一金，带薪年假',
      '弹性工作时间',
      '免费三餐和下午茶',
      '定期团建活动',
      '技术培训和职业发展机会',
    ],
    tags: ['React', 'TypeScript', 'Webpack', '前端架构'],
    postedAt: '2026-03-28',
    deadline: '2026-04-28',
    views: 1234,
    applicants: 56,
    featured: true,
  },
  {
    id: 'job-2',
    title: 'UI/UX设计师',
    company: companies[1],
    location: '深圳',
    type: 'full-time',
    category: 'design',
    salary: {
      min: 20,
      max: 35,
      currency: 'CNY',
    },
    description: '我们正在寻找一位富有创意的UI/UX设计师，负责产品的视觉设计和用户体验优化。你将参与从概念到落地的完整设计流程。',
    requirements: [
      '本科及以上学历，设计相关专业',
      '3年以上UI/UX设计经验',
      '精通Figma、Sketch等设计工具',
      '有移动端和Web端设计经验',
      '良好的审美能力和创新思维',
      '优秀的沟通和协作能力',
    ],
    responsibilities: [
      '负责产品的UI设计和交互设计',
      '制定设计规范和组件库',
      '进行用户研究和可用性测试',
      '与产品、开发团队协作推进项目',
      '持续优化产品的用户体验',
    ],
    benefits: [
      '有竞争力的薪资和股票期权',
      '完善的五险一金',
      '弹性工作制',
      '免费健身房和员工餐厅',
      '年度旅游和团建',
      '设计培训和行业交流机会',
    ],
    tags: ['UI设计', 'UX设计', 'Figma', '交互设计'],
    postedAt: '2026-03-30',
    deadline: '2026-04-30',
    views: 892,
    applicants: 34,
    featured: true,
  },
  {
    id: 'job-3',
    title: '产品经理',
    company: companies[2],
    location: '杭州',
    type: 'full-time',
    category: 'product',
    salary: {
      min: 25,
      max: 40,
      currency: 'CNY',
    },
    description: '我们正在寻找一位有经验的产品经理，负责电商平台的产品规划和迭代。你将深入理解用户需求，推动产品创新。',
    requirements: [
      '本科及以上学历',
      '3年以上产品经理经验',
      '有电商或互联网产品经验',
      '优秀的需求分析和产品规划能力',
      '良好的数据分析能力',
      '出色的沟通和项目管理能力',
    ],
    responsibilities: [
      '负责产品需求分析和功能规划',
      '制定产品路线图和迭代计划',
      '协调设计、开发、测试等团队',
      '进行用户调研和数据分析',
      '持续优化产品功能和体验',
    ],
    benefits: [
      '有吸引力的薪资和年终奖',
      '完善的社保公积金',
      '灵活的工作时间',
      '免费午餐和零食',
      '定期体检和健康保险',
      '职业发展和晋升机会',
    ],
    tags: ['产品规划', '需求分析', '电商', '数据分析'],
    postedAt: '2026-03-29',
    deadline: '2026-04-29',
    views: 756,
    applicants: 28,
    featured: true,
  },
  {
    id: 'job-4',
    title: 'Java后端工程师',
    company: companies[0],
    location: '北京',
    type: 'full-time',
    category: 'technology',
    salary: {
      min: 25,
      max: 45,
      currency: 'CNY',
    },
    description: '我们正在寻找一位Java后端工程师，负责高并发系统的设计和开发。你将参与核心业务系统的架构优化和性能提升。',
    requirements: [
      '本科及以上学历，计算机相关专业',
      '3年以上Java开发经验',
      '精通Spring Boot、MyBatis等框架',
      '熟悉MySQL、Redis等数据库',
      '有高并发系统开发经验',
      '良好的问题分析和解决能力',
    ],
    responsibilities: [
      '负责后端系统的设计和开发',
      '优化系统性能和稳定性',
      '参与技术方案评审',
      '编写技术文档',
      '解决线上问题和故障',
    ],
    benefits: [
      '有竞争力的薪资',
      '六险一金',
      '弹性工作',
      '免费三餐',
      '技术培训',
      '晋升机会',
    ],
    tags: ['Java', 'Spring Boot', 'MySQL', '高并发'],
    postedAt: '2026-03-27',
    views: 1089,
    applicants: 45,
    featured: false,
  },
  {
    id: 'job-5',
    title: '市场营销经理',
    company: companies[3],
    location: '北京',
    type: 'full-time',
    category: 'marketing',
    salary: {
      min: 20,
      max: 35,
      currency: 'CNY',
    },
    description: '我们正在寻找一位市场营销经理，负责品牌推广和市场活动策划。你将制定营销策略，提升品牌影响力。',
    requirements: [
      '本科及以上学历，市场营销相关专业',
      '3年以上市场营销经验',
      '有品牌推广和活动策划经验',
      '熟悉数字营销和社交媒体运营',
      '优秀的文案和创意能力',
      '良好的沟通和团队协作能力',
    ],
    responsibilities: [
      '制定市场营销策略和计划',
      '策划和执行品牌推广活动',
      '管理社交媒体和内容营销',
      '分析市场数据和竞品动态',
      '协调内外部资源推进项目',
    ],
    benefits: [
      '有吸引力的薪资',
      '五险一金',
      '弹性工作',
      '员工餐厅',
      '团建活动',
      '职业发展',
    ],
    tags: ['品牌推广', '活动策划', '数字营销', '社交媒体'],
    postedAt: '2026-03-26',
    views: 678,
    applicants: 23,
    featured: false,
  },
  {
    id: 'job-6',
    title: '数据分析师',
    company: companies[1],
    location: '深圳',
    type: 'full-time',
    category: 'operations',
    salary: {
      min: 18,
      max: 30,
      currency: 'CNY',
    },
    description: '我们正在寻找一位数据分析师，负责业务数据分析和报告。你将通过数据洞察支持业务决策。',
    requirements: [
      '本科及以上学历，统计学或数学相关专业',
      '2年以上数据分析经验',
      '精通SQL和Excel',
      '熟悉Python或R语言',
      '有数据可视化经验',
      '良好的逻辑思维和沟通能力',
    ],
    responsibilities: [
      '进行业务数据分析和挖掘',
      '制作数据报告和可视化图表',
      '建立数据分析模型',
      '支持业务决策和优化',
      '维护数据指标体系',
    ],
    benefits: [
      '有竞争力的薪资',
      '完善的社保',
      '弹性工作',
      '免费午餐',
      '培训机会',
      '晋升通道',
    ],
    tags: ['数据分析', 'SQL', 'Python', '数据可视化'],
    postedAt: '2026-03-25',
    views: 543,
    applicants: 19,
    featured: false,
  },
  {
    id: 'job-7',
    title: '人力资源专员',
    company: companies[2],
    location: '杭州',
    type: 'full-time',
    category: 'hr',
    salary: {
      min: 12,
      max: 20,
      currency: 'CNY',
    },
    description: '我们正在寻找一位人力资源专员，负责招聘和员工关系管理。你将支持公司的人才发展战略。',
    requirements: [
      '本科及以上学历，人力资源相关专业',
      '1年以上HR工作经验',
      '熟悉招聘流程和面试技巧',
      '了解劳动法律法规',
      '良好的沟通和协调能力',
      '细心负责，有服务意识',
    ],
    responsibilities: [
      '负责招聘渠道维护和简历筛选',
      '安排面试和跟进招聘进度',
      '处理员工入离职手续',
      '维护员工关系',
      '协助组织培训和活动',
    ],
    benefits: [
      '稳定的薪资',
      '五险一金',
      '双休',
      '员工餐厅',
      '节日福利',
      '成长空间',
    ],
    tags: ['招聘', '员工关系', 'HR', '人力资源'],
    postedAt: '2026-03-24',
    views: 432,
    applicants: 15,
    featured: false,
  },
  {
    id: 'job-8',
    title: '客户成功经理',
    company: companies[3],
    location: '上海',
    type: 'full-time',
    category: 'customer-service',
    salary: {
      min: 15,
      max: 25,
      currency: 'CNY',
    },
    description: '我们正在寻找一位客户成功经理，负责客户关系维护和满意度提升。你将帮助客户获得最大价值。',
    requirements: [
      '本科及以上学历',
      '2年以上客户服务经验',
      '有B2B客户管理经验优先',
      '优秀的沟通和问题解决能力',
      '良好的服务意识',
      '能承受一定工作压力',
    ],
    responsibilities: [
      '负责客户关系维护和满意度管理',
      '解答客户问题和需求',
      '收集客户反馈并推动改进',
      '协助客户使用产品',
      '定期回访和关怀客户',
    ],
    benefits: [
      '有吸引力的薪资',
      '社保公积金',
      '弹性工作',
      '免费午餐',
      '培训机会',
      '职业发展',
    ],
    tags: ['客户服务', '客户关系', 'B2B', '客户成功'],
    postedAt: '2026-03-23',
    views: 389,
    applicants: 12,
    featured: false,
  },
];

export const featuredJobs = jobs.filter((job) => job.featured);